function getFileParts(p: string) {
    const clean = p.split(/[?#]/)[0];
    const file = clean.replace(/^.*[\\/]/, '');
    const i = file.lastIndexOf('.');
    return {
        file,
        name: i >= 0 ? file.slice(0, i) : file,
        ext: i >= 0 ? file.slice(i + 1) : ''
    };
}

export default getFileParts;